<div class="py-15" *transloco="let translate">
  <ul class="navigation-list">
    @for (item of items; track $index) {
      <li>
        <a
          class="navigation-list--link"
          [class.disabled]="item?.disabled"
          (click)="onLinkClick(item)"
          [routerLinkActive]="['active']"
          [ngClass]="{ active: item.value === activeItem }"
          [routerLink]="item.value"
        >
          {{ translate(prefix + '.' + item.label) }}
        </a>
      </li>
    }
  </ul>
</div>
